import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import Cookies from 'js-cookie';
import { type ReactElement } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

import { AlertDialog, Icon, InlineLink } from '@/components';
import { usePremium } from '@/features/account';
import usePathType from '@/hooks/path-type';
import { LandingWhiteLayout } from '@/layouts/LandingWhiteLayout/LandingWhiteLayout';

import { usePaddleCallbackHandler } from '../../hooks/callback-handler';
import { useCreateTransaction } from '../../hooks/create-transaction';
import { useOpenCheckout } from '../../hooks/open-checkout';
import { PaymentForm } from '../Checkout/PaymentForm/PaymentForm';
import { ProcessDialog } from '../Checkout/ProcessDialog/ProcessDialog';
import { PaymentInformation } from '../PaymentInformation/PaymentInformation';
import styles from './LandingCheckout.module.scss';

export function LandingCheckoutWhite(): ReactElement {
  const { data: isPremium } = usePremium();
  const [searchParams] = useSearchParams();
  const { pricing, checkoutCompleted, interval } = usePaddleCallbackHandler();
  const path = usePathType();

  useCreateTransaction({ path: `/${path}/checkout` });
  const { loading } = useOpenCheckout();

  const checkoutProcessCompleted =
    checkoutCompleted !== undefined && isPremium === true;

  const transaction = searchParams.get('transaction');
  const plan = searchParams.get('plan');

  if (transaction === null && plan === null) {
    <Navigate to="/choose-plan" />;
  }

  const onSkip = (): void => {
    Cookies.set('landing_skip', 'true', { expires: 1 });
  };

  return (
    <LandingWhiteLayout
      leftChild={
        <div className={styles.container}>
          <PaymentInformation pricing={pricing} interval={interval} />
        </div>
      }
      rightChild={
        <div className={styles['right-container']}>
          <div className={styles.skip}>
            <InlineLink href="/" onClick={onSkip}>
              Skip
            </InlineLink>
          </div>
          <div className={styles.content}>
            <div className={styles['price-info']}>
              <h1>Please Enter Your Details</h1>
              <h2 className={styles['price-text']}>
                {pricing.total === null ? (
                  <span className={styles['checkout-payment__loading']}></span>
                ) : (
                  <>
                    {pricing.total} / {interval}
                  </>
                )}
              </h2>
            </div>
            <div className={styles['checkout-form']}>
              {loading ? (
                <div className={styles['checkout-form__loading']}>
                  <Icon icon={faSpinnerThird} spin size="2x" />
                </div>
              ) : null}
              <PaymentForm />
            </div>
          </div>

          <AlertDialog open={checkoutCompleted !== undefined}>
            <ProcessDialog
              pricing={pricing}
              complete={checkoutProcessCompleted}
            />
          </AlertDialog>
        </div>
      }
    />
  );
}
